import * as React from 'react';
import { useXyqarAuth } from '@xyqar/shared-auth';
import { API_BASE } from '../lib/api';
import { PageTitle, Card, Btn } from '../components/ui-kit';
import { BookOpen } from 'lucide-react';

export default function AccountingFEC() {
  const { getToken } = useXyqarAuth();
  const [year, setYear] = React.useState(new Date().getFullYear() - 1);
  const [downloading, setDownloading] = React.useState(false);

  const download = async () => {
    setDownloading(true);
    try {
      const tok = await getToken().catch(() => '');
      const r = await fetch(`${API_BASE}/api/v1/exec/accounting/fec?year=${year}`, {
        headers: tok ? { Authorization: `Bearer ${tok}` } : {},
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `xyqar-fec-${year}.txt`;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div>
      <PageTitle kicker="Accounting" title="FEC export" />
      <Card>
        <div className="flex items-center gap-4">
          <BookOpen className="h-5 w-5 text-white/60" />
          <div className="flex-1">
            <p className="text-sm text-white">French tax authority FEC export (Article A47 A-1)</p>
            <p className="text-xs text-white/40 mt-1">All journal entries for fiscal year, ASCII-tabulated.</p>
          </div>
          <select
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
            className="rounded-md bg-white/5 border border-white/10 px-3 py-2 text-sm text-white"
          >
            {[0, 1, 2, 3].map((d) => {
              const y = new Date().getFullYear() - 1 - d;
              return <option key={y} value={y} className="bg-black">{y}</option>;
            })}
          </select>
          <Btn primary onClick={download} disabled={downloading}>
            {downloading ? 'Exporting…' : 'Export'}
          </Btn>
        </div>
      </Card>
    </div>
  );
}
